import { ReactComponent as Clone } from './clone.svg';
import { ReactComponent as CornerUpLeft } from './corner-up-left.svg';
import { ReactComponent as CornerUpRight } from './corner-up-right.svg';
import { ReactComponent as Tag } from './tag.svg';
import { ReactComponent as Trash } from './trash.svg';
import { ReactComponent as TwoCheckMarks } from './two-checkmarks.svg';

export const ContextMenuIcons = {
  CornerUpLeft,
  CornerUpRight,
  Clone,
  TwoCheckMarks,
  Tag,
  Trash,
};
